import { useDroppable } from '@dnd-kit/core';
import { type SelectedNode } from '@/context/GallerySelectionContext';
import { DraggableItems } from '@/types/dragDrop';
import { DAMNodeType } from '@/types/tree';

// Namespaced so a child in this section can be droppable at the same time as the
// same node in the sidebar tree (which uses `sidebar-${id}` / `${mode}-${id}`).
export const galleryChildDropId = (nodeId: string) => `leading-section-${nodeId}`;

/**
 * Registers a child folder/album row or chip as a drop target.
 *
 * Nothing more: the drop is handled once for the whole section by
 * useGalleryChildrenDropMonitor, which resolves its target from the id built here.
 */
export const useGalleryChildDropTarget = (node: SelectedNode) => {
  const isAlbum = node.type === DAMNodeType.Album;

  const { setNodeRef, isOver } = useDroppable({
    id: galleryChildDropId(node.id),
    data: {
      name: node.name,
      type: isAlbum ? DraggableItems.ALBUM : DraggableItems.FOLDER,
      id: node.id,
      accepts: [DraggableItems.ASSET],
    },
  });

  return { setNodeRef, isOver };
};
